export default __webpack_public_path__ + "static/media/BACNET_IP.748f326a.png";